
export class LocalStorageLogic {
    
    public setObjecItem<Type>(key: string, dobject: Type): void {
        window.localStorage.setItem(key, JSON.stringify(dobject));
    }

    public setStringItem(key: string, value: string): void {
        window.localStorage.setItem(key, value);
    }

    public getObjectItem<Type>(key: string): Type | null {
        const objectJson = window.localStorage.getItem(key);
        if(!objectJson) return null;

        const dobject = JSON.parse(objectJson) as Type;
        return dobject;
    }

    public getStringItem(key: string): string | null {
        return window.localStorage.getItem(key);
    }

    public removeItem(key: string) {
        window.localStorage.removeItem(key);
    }
}

export const LocalStorageLogicSingleton = new LocalStorageLogic();